import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid w-100 fluid mt-5 mx-5 p-5" }
const _hoisted_2 = { class: "col-12 lg:col-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-content-center pt-5" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "pi pi-fw pi-user",
    style: {"font-size":"15rem"}
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-content-center" }, "Benutzer", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex justify-content-center",
  style: {"height":"100px"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    style: {"width":"400px"},
    class: "text-center"
  }, " Hier finden Sie eine Liste der aktuellen Benutzer und deren Informationen wie Name, E-Mail-Adresse und Rolle. Fügen Sie einen neuen Benutzer hinzu oder bearbeiten Sie einen bestehenden, indem Sie die erforderlichen Informationen eingeben und die Änderungen speichern. ")
], -1)
const _hoisted_6 = { class: "flex justify-content-center" }
const _hoisted_7 = { class: "col-12 lg:col-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-content-center pt-5" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "pi pi-fw pi-book",
    style: {"font-size":"15rem"}
  })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-content-center" }, "Seiten", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex justify-content-center",
  style: {"height":"100px"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    style: {"width":"400px"},
    class: "text-center"
  }, " Erstellen, verwalten und veröffentlichen Sie statische Seiten, ohne spezielle technische Kenntnisse zu benötigen. Organisieren von Inhalten wie Texten, Bildern, Videos und anderen Medien. ")
], -1)
const _hoisted_11 = { class: "flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_DefaultLayout = _resolveComponent("DefaultLayout")!

  return (_openBlock(), _createBlock(_component_DefaultLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Card, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToUsers())),
            style: {"cursor":"pointer"}
          }, {
            header: _withCtx(() => [
              _hoisted_3
            ]),
            title: _withCtx(() => [
              _hoisted_4
            ]),
            content: _withCtx(() => [
              _hoisted_5
            ]),
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_Button, {
                  icon: "pi pi-user",
                  class: "p-button-text",
                  label: "Benutzer",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToUsers()))
                })
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Card, {
            onClick: _ctx.goToPages,
            style: {"cursor":"pointer"}
          }, {
            header: _withCtx(() => [
              _hoisted_8
            ]),
            title: _withCtx(() => [
              _hoisted_9
            ]),
            content: _withCtx(() => [
              _hoisted_10
            ]),
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Button, {
                  icon: "pi pi-book",
                  class: "p-button-text",
                  label: "Seiten",
                  onClick: _ctx.goToPages
                }, null, 8, ["onClick"])
              ])
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }))
}